
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import { FileService } from "@/core/services/FileService";
  import * as moment from "moment"
  import { ElMessage, ElMessageBox } from "element-plus";
   
  export default defineComponent({
    name: "General",
    components : {
    },
    props : {
      idEtat : Number,
      isOpen : Number,
      apiName : String,
    },
    setup(props, { emit }) {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        drawerAddItem : 0,
        masqueSubStitle : 0,
        rEtat : {} as any,
        title : 'Nouvelle saisie',
        idDepense : 0,
        idFolder: 0,
        refresh : 0,
        idEtat : 0,
        allRest: {} as any,
        loading: true,
        comsHisto: false,
        n2fEnvoyé: 0
    });
    
    onMounted(async() => {
      
      const allRest = await mAxiosApi.prototype.getAxios("/getPermissions");
      state.allRest =  allRest.results.filter(
          (item: any) =>item.per_code_permission == 'ERP_TRAITE_N2F'
      );

      if (!props.isOpen) return false;
      if (props.idEtat as any > 0) {
          const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + props.idEtat);
          // const getFolder = await N2FfileService.createFolder(("Etat mensuel " + getEtatEmp.results[0].eem_seq));
          // state.idFolder = getFolder
          state.rEtat = getEtatEmp.results[0];
          console.log('etat :', state.rEtat);
          if (((state.rEtat.eem_status == 'Brouillon' || state.rEtat.eem_status == 'Refusé')) ||
          ((state.rEtat.eem_status != 'Validé'))) {
            state.title = "Modifier l'état mensuel";
          }else{
            state.title = "Afficher l'état mensuel";
          }
      } else{
        const newEtatEmp = await mAxiosApi.prototype.getAxios("/newEtatEmp");
        // const newFolder = await N2FfileService.createFolder(("Etat mensiel " + newEtatEmp.results.eem_seq));
        // state.idFolder = newFolder;
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + newEtatEmp.results.eem_seq);
        state.rEtat = getEtatEmp.results[0];
        refreshParent();
      }
      
      state.idEtat = state.rEtat.eem_seq;

      if (!modeDisabled() && 
          (!state.rEtat.eem_usage_voiture_perso || state.rEtat.eem_usage_voiture_perso === '') && 
          state.rEtat.eem_usage_voiture_perso_precedent) {
        state.rEtat.eem_usage_voiture_perso = state.rEtat.eem_usage_voiture_perso_precedent;
      }

      if (!modeDisabled() && 
          (!state.rEtat.eem_usage_voiture_pro || state.rEtat.eem_usage_voiture_pro === '') && 
          state.rEtat.eem_usage_voiture_perso_precedent) {
        state.rEtat.eem_usage_voiture_pro = state.rEtat.eem_usage_voiture_pro_precedent;
      }

      state.loading = false;

    });

    const close = () => {
      emit("closeEtatAddEdit", 0);
    };

    

    const removeEtatEmp = () => {
      const rEtat = {
        eem_seq: state.rEtat.eem_seq,
      };

      mAxiosApi.post("/deleteEtatEmp", rEtat)
      .then(() => {
        refreshParent();
        close();
      })

    };

    const sendEtat = (status) => {

      if(state.rEtat.emp_x_voiture == 1 && (status == 'En attente de validation' || status == 'Refusé')){
        const pctTotal = Math.fround(state.rEtat.eem_usage_voiture_perso) + Math.fround(state.rEtat.eem_usage_voiture_pro);
        
        if(pctTotal != 100){
          ElMessage({
            type: 'error',
            message: "Total n'est pas égal à 100%, merci de refaire la saisie des répartitions",
          })
          return
        }
      }

      if(state.rEtat.emp_x_voiture == 1 && (status == 'En attente de validation' || status == 'Refusé')) {
        const kmPrecedent = state.rEtat.eem_kms_mois_precedent;
        if (kmPrecedent != null && kmPrecedent !== '' && Number(kmPrecedent) > Number(state.rEtat.eem_kms_mois)) {
          ElMessage({
            type: 'error',
            message: "Le kilométrage saisi ne peut pas être inférieur au dernier relevé du véhicule affecté : " + kmPrecedent,
          })
          return
        }
      }

      if(state.rEtat.eem_x_conges != 1){
        ElMessage({
          type: 'error',
          message: "Si vous avez pris des congés pendant cette période pensez à bien saisir vos indisponibilités svp",
        })
      }

      if(state.rEtat.eem_tot_heures_hno > 0 && (!state.rEtat.eem_commentaire_hno || state.rEtat.eem_commentaire_hno.trim() === '') && (status == 'En attente de validation' || status == 'Refusé')){
        ElMessage({
          type: 'error',
          message: "Veuillez saisir les détais de vos heures HNO dans le champ commentaires svp. ",
        })
        return
        
      }

      const rEtat = {
        eem_seq: state.rEtat.eem_seq,
        eem_repas_mois: state.rEtat.eem_repas_mois,
        eem_kms_mois: state.rEtat.eem_kms_mois,
        eem_usage_voiture_perso: state.rEtat.eem_usage_voiture_perso,
        eem_usage_voiture_pro: state.rEtat.eem_usage_voiture_pro,
        eem_x_conges: state.rEtat.eem_x_conges,
        eem_tot_heures_hno: state.rEtat.eem_tot_heures_hno,
        eem_commentaire_hno: state.rEtat.eem_commentaire_hno,
        eem_status: status
      };

      mAxiosApi.post("/sendEtat", rEtat)
      .then(() => {
        refreshParent();
        close();
      })

    };

    const getUsagePersoPlaceholder = () => {
      if (state.rEtat.eem_usage_voiture_perso_precedent) {
        return `ex. 50 (précédent: ${state.rEtat.eem_usage_voiture_perso_precedent}%)`;
      }
      return "ex. 50";
    };

    
    const refreshParent = () => {
      emit("refresh", 1);
    };

    const refresh = async () => {
      const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + state.idEtat);
      state.rEtat = getEtatEmp.results[0];
      state.refresh = state.refresh +1;
      refreshParent();
    };

    const modeDisabled = () => {
      if (state.rEtat.eem_status=='Brouillon' || state.rEtat.eem_status=='Refusé') return false;
      return true;
    };

    const formatDate = (date) => {
      return moment.default(date).format("DD/MM/YYYY");
    }

    const checkN2f = (int) => {
      const value = Number(int);
      state.n2fEnvoyé = value === 1 ? 1 : 0;

      if (state.n2fEnvoyé == 1) {
        getRepas();
      }
    }

    const getRepas = async() => {
      const allRepas = await mAxiosApi.prototype.getAxios("/getRepas/" + state.rEtat.eem_knum_employe);
      state.rEtat.eem_repas_mois =  allRepas.results[0].total_jours   
    }

      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          close,
          refreshParent,
          refresh,
          removeEtatEmp,
          sendEtat,
          modeDisabled,
          formatDate,
          getUsagePersoPlaceholder,
          checkN2f,
          getRepas
      };
    },
  });
  